<template>

   <div class="offcanvas-header mx-4">
      <div>
         <p class="offcanvas-title pb-4 text-center"> {{ GetOrganisationName(this.testimonial.organisation_id) }}'s Testimonial</p>

         <hr class="menu-divider" />

      </div>

   </div>

   <div ref="sidebarBodyRef" class="offcanvas-body mx-4">
      <!-- <div class="tab-content" id="pills-tabContent"> class="tab-pane fade show active" -->
      <div id="pills-details" role="tabpanel" aria-labelledby="pills-details-tab">
         <TestimonialForm ref="testimonialFormRef" @onEditSubmitForm="onSubmitForm" />
      </div>
      <!-- </div> -->
   </div>
</template>

<script>
import TestimonialForm from '@/components/ContentLibrary/TestimonialForm.vue';
export default ({

   components: {
      TestimonialForm
   },

   props: {
      id: {
         type: String,
      },
   },

   emits: ['onEditForm'],

   data() {
      return {
         testimonial: {},
         organisations: [],
         hasBeenEdited: false
      }
   },

   created() {
      this.init()
   },

   computed: {
      item() {
         return this.id
      },

   },

   watch: {
      item() {
         this.init()
      },

   },

   methods: {

      init() {
         this.getAuthOrganisations()
         this.getTestimonial(this.id)
      },

      onSubmitForm() {
         this.init()
         this.hasBeenEdited = true
         this.$emit("onEditForm", true)
      },

      GetOrganisationName(org_id) {
         const organisation = this.organisations.find(org => org.id === org_id);
         return organisation ? organisation.name : "No Organisation Name"; // Or handle the case where no match is found
      },

      async getAuthOrganisations() {
         await this.$axios_auth.get("/vertex/organisations")
            .then((response) => {
               this.organisations = response.data.organisations
            })
            .catch((error) => {
               console.error(error)
               // this.$toast.error(error.response.data.message)
            })
      },

      async getTestimonial(id) {
         await this.$axios.get("/testimonials/" + id)
            .then((response) => {
               this.testimonial = response.data.testimonial
               this.$refs.testimonialFormRef.isEdit(response.data.testimonial.id)
            })
            .catch((error) => {
                console.error(error)
               // this.$toast.error(error)
            })

      },
   }
})
</script>

<style scoped>
.offcanvas-title {
   color: #435666;
   font-weight: 900;
   font-size: 24px;
}

.leads-menu-tab button {
   border-radius: 10px !important;
}

/* .leads-menu-tab .nav-item { */
/* background: #435666; */
/* justify-content: center; */
/* height: 40px; */
/* } */

.vr {
   width: 2px;
   height: 40px;
   margin-left: 1rem;
   margin-right: 1rem;
}

.menu-divider {
   width: 640px;
   /* height: 2px; */
   /* color: #F0F0F0; */
   border-width: 2px;
   /* margin-top: 1px; */
   margin-bottom: 1px;
}

.leads-menu-tab .nav-link {
   color: #435666;
   height: 40px;
   min-width: 95px;
   padding: 1rem;
   font-weight: 400;
}

.leads-menu-tab .nav-link.active {
   background-color: #00A0C1;
   color: #fff;
   font-weight: 900;
}

/* ========== SCROLLBAR ========== */

/* scrollbar wrapper */
::-webkit-scrollbar {
   width: 8px;
   /* margin: 10px; */
   /* border: none;
    background: transparent; */
}

/* Track */
::-webkit-scrollbar-track {
   margin: 10px;
   border-radius: 10px;
   border-left: 2.5px solid transparent;
   border-right: 2.5px solid transparent;
   background-clip: content-box;
   -webkit-box-shadow: inset 0 0 5px #D9D9D9;
   background-color: #D9D9D9;
}

/* Handle */
::-webkit-scrollbar-thumb {
   /* background: #00A0C1; 
   border-radius: 10px; */
   background: #00A0C1;
   border-radius: 10px;
   /* width: 10px; */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
   background: #00A0C1;
}

/* ========== END -- SCROLLBAR ========== */
</style>